import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './lammie.css';

export default class Lammie extends Component {
    constructor(props) {
        super(props);
        this.state = {
            printListSize: 0,
            saveMessage: "",
            saveErrorMessage: "",
            notes: ""
        };

        this.addToLammiePrintList = this.addToLammiePrintList.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        this.saveLammie = this.saveLammie.bind(this);
    }

    componentDidMount() {
        this.getPrintListSize();
    }

    renderGlance(glance) {
        if (glance) {
            return (
                <div><b>Glance:</b> {glance}</div>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }

    renderGaze(gaze) {
        if (gaze) {
            return (
                <div>
                    <br />
                    <b>Gaze:</b> {gaze}
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    render() {
        const leftStyle = {
            fontSize: this.props.fontSize.left + "px"
        };

        const rightStyle = {
            fontSize: this.props.fontSize.right + "px"
        };

        return (
            <div>
                <table className="lammie">
                    <tbody>
                        <tr>
                            <td className="lammie-data lammie-data-left" style={leftStyle}>
                                <b>{this.props.magicItem.lammieTitle}</b>
                                <br />
                                {this.props.magicItem.lammieText}
                            </td>
                            <td className="lammie-data lammie-data-right" style={rightStyle}>
                                {this.renderGlance(this.props.magicItem.thirdEye.glance)}
                                {this.renderGaze(this.props.magicItem.thirdEye.gaze)}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <div className="mb-3">
                    <Button className="d-inline" variant="primary" onClick={this.addToLammiePrintList}>Add to print list</Button>{' '}
                    <div className="d-inline">Items in print list: {this.state.printListSize}</div>
                </div>
                <div>
                    <Form.Group className="mb-3 w-50">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                            type="text"
                            value={this.state.notes}
                            onChange={this.handleNotesChange} />
                    </Form.Group>
                    <Button className="d-inline" variant="success" onClick={this.saveLammie}>Save Lammie</Button>{' '}
                    <div className="d-inline text-success">{this.state.saveMessage}</div>
                    <div className="d-inline text-danger">{this.state.saveErrorMessage}</div>
                </div>
                <br />
            </div>
        )
    }

    async getPrintListSize() {
        const response = await fetch("print/getlammieprintlistsize");
        const data = await response.json();
        this.setState({ printListSize: data });
    }

    async addToLammiePrintList() {
        const printableMagicItem = {
            lammieTitle: this.props.magicItem.lammieTitle,
            lammieText: this.props.magicItem.lammieText,
            thirdEye: this.props.magicItem.thirdEye,
            fontSizeLeft: this.props.fontSize.left,
            fontSizeRight: this.props.fontSize.right
        }

        const settings = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(printableMagicItem)
        };

        const response = await fetch("print/addtolammieprintlist", settings);
        const data = await response.json();
        this.setState({ printListSize: data });
    }

    async handleNotesChange(e) {
        this.setState({ notes: e.target.value });
    }

    async saveLammie() {
        const saveableMagicItem = {
            lammieTitle: this.props.magicItem.lammieTitle,
            lammieText: this.props.magicItem.lammieText,
            thirdEye: this.props.magicItem.thirdEye,
            notes: this.state.notes
        }

        const settings = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(saveableMagicItem)
        };

        const response = await fetch("lammie/savelammie", settings);

        if (response.ok) {
            this.setState({ saveMessage: "Saved " + this.props.magicItem.lammieTitle, saveErrorMessage: "" });
        } else {
            this.setState({ saveMessage: "", saveErrorMessage: "Error saving " + this.props.magicItem.lammieTitle });
        }        
    }
}
